<template>
  <p>{{ text }}</p>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      text: ""
    };
  },
  props: {
    categoryId: {
      type: Number
    }
  },
  watch: {
    categoryId: {
      deep: true,
      handler: function() {
        this.getProjectCategoryId();
      }
    }
  },
  mounted() {
    this.getProjectCategoryId();
  },
  methods: {
    async getProjectCategoryId() {
      try {
        const data = await Api.Project.getProjectCategoriesDetail(
          this.categoryId
        );
        this.text = data.name;
      } catch (e) {
        this.$Message.error(e);
      }
    }
  }
};
</script>
<style lang="less" scoped></style>
